<div class="d-sm-flex align-items-center justify-content-between mb-4">
  <h1 class="h2 mb-0">Evenimente</h1>
  <ul class="nav nav-tabs flex-nowrap mb-0 pt-3 pt-sm-0" role="tablist">
    <li class="nav-item flex-fill flex-sm-grow-0" role="presentation">
      <button (click)="onTabSelected(tabs.EVENTS)" [ngClass]="{'active' : selectedTab === tabs.EVENTS}" class="nav-link"
        type="button" role="tab">
        <i class="ai-gift me-2"></i><span class="d-none d-md-inline">Evenimentele mele</span><span
          class="d-inline d-md-none">Evenimente</span></button>
    </li>
    <li class="nav-item flex-fill flex-sm-grow-0" role="presentation">
      <button (click)="onTabSelected(tabs.INVITATIONS)" [ngClass]="{'active' : selectedTab === tabs.INVITATIONS}"
        class="nav-link" type="button" role="tab">
        <i class="ai-mail me-2"></i><span class="d-none d-md-inline">Invitatiile mele</span><span
          class="d-inline d-md-none">Invitatii</span></button>
    </li>
  </ul>
</div>
<div class="card border-0 py-1 p-md-2 p-xl-3 p-xxl-4">
  <div class="card-body pb-4">
    <!-- Event list-->
    <div class="tab-content">
      <!-- Events -->
      <div [ngClass]="{'show active': selectedTab === tabs.EVENTS}" class="tab-pane fade" role="tabpanel">
        <div class="d-sm-flex align-items-center pb-4 mt-sm-n1 mb-0 mb-lg-1 mb-xl-3">
          <div class="d-flex align-items-center">
            <i class="ai-gift text-primary lead pe-1 me-2"></i>
            <h2 class="h4 mb-0">Evenimentele mele</h2>
          </div>
          <div class="ms-auto pt-3 pt-sm-0">
            <a [routerLink]="['/user/creare-eveniment']" class="btn btn-primary btn-sm w-100 w-sm-auto">
              <i class="ai-calendar-plus me-1"></i>Creeaza eveniment</a>
          </div>
        </div>
        <div class="mb-3">
          <div class="position-relative"><i
              class="ai-search fs-lg position-absolute top-50 start-0 translate-middle-y ms-3"></i>
            <input [(ngModel)]="searchEvents" (ngModelChange)="onFilterEventsChange()"
              class="form-control form-control-sm ps-5" type="search" placeholder="Cauta dupa titlu...">
          </div>
        </div>

        <ng-container *ngIf="events">
          <gs-event-list [events]="filteredEvents" [itemsPerPage]="9" [canShowAdminButtons]="true"></gs-event-list>
        </ng-container>

        <!-- No items -->
        <div *ngIf="events?.length === 0" class="card border-0 bg-secondary text-center">
          <svg-icon src="assets/images/illustrations/no-data.svg" svgClass="w-50 h-50 mt-3"></svg-icon>
          <div class="card-body">
            <h4 class="card-title">Nu ai creat niciun eveniment</h4>
            <p class="card-text">Poti crea un eveniment pentru a oferi un cadou de grup unui prieten/coleg (<span class="text-primary">#ChetaDigitala</span>) sau chiar pentru tine 🙂</p>
            <a [routerLink]="['/cum-functioneaza']" class="btn btn-outline-primary w-100 w-sm-auto mb-2 mb-sm-0">Cum
              functioneaza</a>
            <a [routerLink]="['/user/creare-eveniment']" class="btn btn-primary w-100  w-sm-auto ms-sm-2">Creeaza
              eveniment</a>
          </div>
        </div>

        <!-- No filter results template -->
        <div *ngIf="events?.length > 0 && filteredEvents?.length === 0" class="card border-0 bg-secondary text-center">
          <svg-icon src="assets/images/illustrations/no-search-results.svg" svgClass="w-50 h-50 mt-3"></svg-icon>
          <div class="card-body">
            <h4 class="card-title">Nicio inregistrare</h4>
            <p class="card-text">Ne pare rau, nu a fost gasit niciun rezultat care sa corespunda cautarii.</p>
          </div>
        </div>

        <!-- Loading template -->
        <div *ngIf="!events" class="row row-cols-1 row-cols-md-2 row-cols-xl-3 g-4">
          <div *ngFor="let item of [].constructor(6)" class="col">
            <div class="card" aria-hidden="true">
              <div class="position-relative placeholder-glow">
                <div class="card-img-top placeholder ratio ratio-16x9"></div>
                <i class="ai-image position-absolute top-50 start-50 translate-middle fs-1 opacity-50"></i>
              </div>
              <div class="card-body">
                <h5 class="card-title placeholder-glow">
                  <span class="placeholder col-6"></span>
                </h5>
                <p class="card-text placeholder-glow">
                  <span class="placeholder placeholder-sm col-7 me-2"></span>
                  <span class="placeholder placeholder-sm col-4"></span>
                  <span class="placeholder placeholder-sm col-4 me-2"></span>
                  <span class="placeholder placeholder-sm col-6"></span>
                  <span class="placeholder placeholder-sm col-8"></span>
                </p>
                <a href="#" tabindex="-1" class="btn btn-primary disabled placeholder col-6 placeholder-glow"></a>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Invitations -->
      <div [ngClass]="{'show active': selectedTab === tabs.INVITATIONS}" class="tab-pane fade" role="tabpanel">
        <div class="d-sm-flex align-items-center pb-4 mt-sm-n1 mb-0 mb-lg-1 mb-xl-3">
          <div class="d-flex align-items-center">
            <i class="ai-mail text-primary lead pe-1 me-2"></i>
            <h2 class="h4 mb-0">Invitatiile mele</h2>
          </div>
          <div class="ms-auto pt-3 pt-sm-0">
            <div class="position-relative mb-lg-2"><i
                class="ai-search fs-lg position-absolute top-50 start-0 translate-middle-y ms-3"></i>
              <input [(ngModel)]="searchInvitations" (ngModelChange)="onFilterInvitationsChange()"
                class="form-control form-control-sm ps-5" type="search" placeholder="Cauta dupa titlu...">
            </div>
          </div>
        </div>
        <ng-container *ngIf="invitations">
          <gs-event-list [events]="filteredInvitations" [itemsPerPage]="9"
            [canShowContributeButton]="true"></gs-event-list>
        </ng-container>

        <!-- No items -->
        <div *ngIf="invitations?.length === 0" class="card border-0 bg-secondary text-center">
          <svg-icon src="assets/images/illustrations/no-data.svg" svgClass="w-50 h-50 mt-3"></svg-icon>
          <div class="card-body">
            <h4 class="card-title">Nicio inregistrare</h4>
            <p class="card-text">Nu ai niciun eveniment la care ai fost invitat sa contribui. Nicio grija, te vom
              anunta imediat ce vei primi o invitatie!</p>
            <a [routerLink]="['/cum-functioneaza']" class="btn btn-outline-primary w-100 w-sm-auto mb-2 mb-sm-0">Cum
              functioneaza</a>
            <a [routerLink]="['/user/creare-eveniment']" class="btn btn-primary w-100  w-sm-auto ms-sm-2">Creeaza
              eveniment</a>
          </div>
        </div>

        <!-- No filter results template -->
        <div *ngIf="invitations?.length > 0 && filteredInvitations?.length === 0"
          class="card border-0 bg-secondary text-center">
          <svg-icon src="assets/images/illustrations/no-search-results.svg" svgClass="w-50 h-50 mt-3"></svg-icon>
          <div class="card-body">
            <h4 class="card-title">Nicio inregistrare</h4>
            <p class="card-text">Ne pare rau, nu a fost gasit niciun rezultat care sa corespunda cautarii.</p>
          </div>
        </div>

        <!-- Loading template -->
        <div *ngIf="!invitations" class="row row-cols-1 row-cols-md-2 row-cols-xl-3 g-4">
          <div *ngFor="let item of [].constructor(6)" class="col">
            <div class="card" aria-hidden="true">
              <div class="position-relative placeholder-glow">
                <div class="card-img-top placeholder ratio ratio-16x9"></div>
                <i class="ai-image position-absolute top-50 start-50 translate-middle fs-1 opacity-50"></i>
              </div>
              <div class="card-body">
                <h5 class="card-title placeholder-glow">
                  <span class="placeholder col-6"></span>
                </h5>
                <p class="card-text placeholder-glow">
                  <span class="placeholder placeholder-sm col-7 me-2"></span>
                  <span class="placeholder placeholder-sm col-4"></span>
                  <span class="placeholder placeholder-sm col-4 me-2"></span>
                  <span class="placeholder placeholder-sm col-6"></span>
                  <span class="placeholder placeholder-sm col-8"></span>
                </p>
                <a href="#" tabindex="-1" class="btn btn-primary disabled placeholder col-6 placeholder-glow"></a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

  </div>
</div>
